export class BasicModel {
  public idtechnique: number;
  public id: number;
  public label: string;
  public label2: string;
  public checked: boolean;
  public date: string;
  public accountingDate: string;
  public idParent: number;

  /* Permet d'avoir un constructeur surchargÃ© grace aux "?"*/
  constructor(
    id?: number,
    label?: string,
    label2?: string,
    checked?: boolean,
    idtechnique?: number,
    date?: string,
    accountingDate?: string,
    idParent?: number
  ) {
    this.id = id;
    this.label = label;
    this.label2 = label2;
    this.checked = checked;
    this.idtechnique = idtechnique;
    this.date = date;
    this.accountingDate = accountingDate;
    this.idParent = idParent;
  }
}
